<template>
  <el-table
    :data="tableData"
    height="515"
    style="width: 100%"
    border
    :row-style="{ height: '45px' }"
    :cell-style="{ padding: '0px' }"
    header-row-class-name="table-header"
  >
    <el-table-column prop="id" label="ID" />
    <el-table-column prop="countyName" label="市" />
    <el-table-column prop="townName" label="區域" />
    <el-table-column label="交叉路口" width="300">
      <template slot-scope="scope">
        <div class="intersection-inputs">
          <el-input
            v-model="scope.row.roadName"
            placeholder="交叉路口1"
            :disabled="true"
          />
          <el-input
            v-model="scope.row.intersectionName"
            placeholder="交叉路口2"
            :disabled="true"
            style="margin-top: 5px"
          />
        </div>
      </template>
    </el-table-column>
    <el-table-column label="操作" align="center">
      <template slot-scope="scope">
        <el-button type="primary" size="mini" @click="handleEdit(scope.row)">
          &nbsp;&nbsp;編輯&nbsp;&nbsp;
        </el-button>
      </template>
    </el-table-column>
    <el-table-column label="最後編輯日期" width="300">
      <template slot-scope="scope">
        <div>{{ formatDate(scope.row.updatedAt) }}</div>
        <div>{{ scope.row.teamManagerName || '-' }}</div>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import dayjs from 'dayjs'

export default {
  props: ['tableData'],
  methods: {
    handleEdit(row) {
      this.$emit('selectEditIntersection', row)
    },
    formatDate(date) {
      return dayjs(date).format('YYYY-MM-DD HH:mm:ss')
    },
  },
}
</script>

<style scoped>
.table-header > th,
.table-header > tr {
  font-weight: 400;
  background: #eee !important;
}
.intersection-inputs {
  padding: 5px;
}
</style>



// WEBPACK FOOTER //
// src/pages/teamBuildLocation/IntersectionTable.vue